import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import getLangBySubdomain from './utils/getLangBySubdomain'
import {i18nReady} from './i18n'
import './assets/styles/global.scss'

document.documentElement.setAttribute('lang', getLangBySubdomain())

const rootEl = document.getElementById('root')

//A prerendered page ships static HTML inside #root. Hydrate it (reusing that DOM for a fast, stable
//paint) instead of throwing it away — but wait for i18n so the client's first render matches the
//baked-in translations. Non-prerendered routes (the constructor, book pages, the plain SPA shell)
//have an empty #root, so they mount normally.
if (rootEl.hasChildNodes()) {
  i18nReady.then(() => ReactDOM.hydrateRoot(rootEl, <App/>))
} else {
  ReactDOM.createRoot(rootEl).render(<App/>)
}
